(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7043],{

/***/ 40784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ isPropValid; }
});

;// CONCATENATED MODULE: ./node_modules/@emotion/is-prop-valid/node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}



;// CONCATENATED MODULE: ./node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);




/***/ }),

/***/ 5597:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seu-hype-seu-estilo",
      function () {
        return __webpack_require__(39853);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 50121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Banner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37265);
/* harmony import */ var _bannerDefault_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67202);
/* harmony import */ var _bannerDefault_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_bannerDefault_module_scss__WEBPACK_IMPORTED_MODULE_3__);





function Banner(param) {
    var image = param.image, _children = param.children, children = _children === void 0 ? "" : _children, _width = param.width, width = _width === void 0 ? "100%" : _width, _height = param.height, height = _height === void 0 ? "fit-content" : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_bannerDefault_module_scss__WEBPACK_IMPORTED_MODULE_3___default().bannerContainer),
        style: {
            width: width,
            height: height
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: (image === null || image === void 0 ? void 0 : image.src) || "/img/loading-wall.gif",
                loader: _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_4__/* .customLoader */ .l,
                width: width,
                layout: "fill",
                objectFit: "cover",
                quality: 100,
                alt: "Hype Empreendimentos",
                priority: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_bannerDefault_module_scss__WEBPACK_IMPORTED_MODULE_3___default().childrenContainer),
                children: children
            })
        ]
    });
}


/***/ }),

/***/ 38280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MetaTags; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function MetaTags(param) {
    var data = param.data;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    if (!data) return null;
    var ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, _descricao, ref21, ref22;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                children: [
                    " ",
                    (ref8 = data === null || data === void 0 ? void 0 : data.titulo) !== null && ref8 !== void 0 ? ref8 : "",
                    " "
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: (ref9 = data === null || data === void 0 ? void 0 : data.descricao) !== null && ref9 !== void 0 ? ref9 : ""
            }, "metadescription"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "name",
                content: (ref10 = data === null || data === void 0 ? void 0 : data.titulo) !== null && ref10 !== void 0 ? ref10 : ""
            }, "googlename"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "description",
                content: (ref11 = data === null || data === void 0 ? void 0 : data.descricao) !== null && ref11 !== void 0 ? ref11 : ""
            }, "googledescription"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "image",
                content: (ref12 = data === null || data === void 0 ? void 0 : (ref = data.imagem) === null || ref === void 0 ? void 0 : ref.url) !== null && ref12 !== void 0 ? ref12 : ""
            }, "googleimage"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: (ref13 = data === null || data === void 0 ? void 0 : data.rota) !== null && ref13 !== void 0 ? ref13 : ""
            }, "ogurl"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }, "ogtype"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: (ref14 = data === null || data === void 0 ? void 0 : data.titulo) !== null && ref14 !== void 0 ? ref14 : ""
            }, "ogtitle"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: (ref15 = data === null || data === void 0 ? void 0 : data.descricao) !== null && ref15 !== void 0 ? ref15 : ""
            }, "ogdesc"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "image",
                content: (ref16 = data === null || data === void 0 ? void 0 : (ref1 = data.imagem) === null || ref1 === void 0 ? void 0 : ref1.url) !== null && ref16 !== void 0 ? ref16 : ""
            }, "image"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                itemProp: "image",
                content: (ref17 = data === null || data === void 0 ? void 0 : (ref2 = data.imagem) === null || ref2 === void 0 ? void 0 : ref2.url) !== null && ref17 !== void 0 ? ref17 : ""
            }, "ogimage"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: (ref18 = data === null || data === void 0 ? void 0 : (ref3 = data.imagem) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.width) === null || ref4 === void 0 ? void 0 : ref4.toString()) !== null && ref18 !== void 0 ? ref18 : ""
            }, "ogimagewidth"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: (ref19 = data === null || data === void 0 ? void 0 : (ref5 = data.imagem) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.height) === null || ref6 === void 0 ? void 0 : ref6.toString()) !== null && ref19 !== void 0 ? ref19 : ""
            }, "ogimageheight"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: "Hype Empreendimentos"
            }, "ogsitename"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: (ref20 = data === null || data === void 0 ? void 0 : data.titulo) !== null && ref20 !== void 0 ? ref20 : ""
            }, "twittertitle"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: (_descricao = data.descricao) !== null && _descricao !== void 0 ? _descricao : ""
            }, "twitterdescription"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: (ref21 = data === null || data === void 0 ? void 0 : (ref7 = data.imagem) === null || ref7 === void 0 ? void 0 : ref7.url) !== null && ref21 !== void 0 ? ref21 : ""
            }, "twitterimage"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:domain",
                content: "hypeempreendimentos.com.br"
            }, "twitterdomain"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:url",
                content: (ref22 = data === null || data === void 0 ? void 0 : data.rota) !== null && ref22 !== void 0 ? ref22 : ""
            }, "twitterurl")
        ]
    });
}


/***/ }),

/***/ 1602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Conheca; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_BannerDefault__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50121);
/* harmony import */ var _hooks_useMedia__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55255);
/* harmony import */ var _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37265);
/* harmony import */ var _conheca_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85426);
/* harmony import */ var _conheca_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_conheca_module_scss__WEBPACK_IMPORTED_MODULE_4__);






var parse = __webpack_require__(30488);
function Conheca(param) {
    var dados = param.dados;
    var isMobile = (0,_hooks_useMedia__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("(max-width: 768px)");
    if (!dados) return null;
    var titulo = dados.titulo, texto = dados.texto, banner = dados.banner, bannerMobile = dados.bannerMobile, imagem = dados.imagem;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BannerDefault__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        image: {
            src: isMobile ? bannerMobile : banner
        },
        width: "100%",
        height: "fit-content",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_conheca_module_scss__WEBPACK_IMPORTED_MODULE_4___default().section),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_conheca_module_scss__WEBPACK_IMPORTED_MODULE_4___default().text),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            children: parse(titulo)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: parse(texto)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                    className: (_conheca_module_scss__WEBPACK_IMPORTED_MODULE_4___default().image),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            alt: titulo,
                            src: imagem || "/img/image_icon.png",
                            loader: _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_5__/* .customLoader */ .l,
                            width: "1080",
                            height: "720",
                            priority: true
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figcaption", {
                            children: [
                                "Imagem:",
                                titulo
                            ]
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 35121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Conhecermais; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _conhecerMais_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84983);
/* harmony import */ var _conhecerMais_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_conhecerMais_module_scss__WEBPACK_IMPORTED_MODULE_1__);


var parse = __webpack_require__(30488);
function Conhecermais(param) {
    var dados = param.dados;
    if (!dados) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_conhecerMais_module_scss__WEBPACK_IMPORTED_MODULE_1___default().section),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: parse(dados.texto1)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: parse(dados.texto2)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                        href: "https://www.plugape.com.br/",
                        target: "_blank",
                        rel: "noreferrer",
                        children: [
                            "Conhe\xe7a mais sobre a",
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: "Plug Ap\xea"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 75964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Detalhes; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_BannerDefault__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50121);
/* harmony import */ var _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37265);
/* harmony import */ var _detalhes_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65773);
/* harmony import */ var _detalhes_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_detalhes_module_scss__WEBPACK_IMPORTED_MODULE_3__);





var parse = __webpack_require__(30488);
function Detalhes(param) {
    var dados = param.dados;
    if (!dados) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BannerDefault__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        image: {
            src: "/img/backgroundpolitica.webp"
        },
        width: "100%",
        height: "fit-content",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_detalhes_module_scss__WEBPACK_IMPORTED_MODULE_3___default().section),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_detalhes_module_scss__WEBPACK_IMPORTED_MODULE_3___default().text),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            children: parse(dados.titulo)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: parse(dados.texto)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_detalhes_module_scss__WEBPACK_IMPORTED_MODULE_3___default().decor1)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                            className: (_detalhes_module_scss__WEBPACK_IMPORTED_MODULE_3___default().banner2),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    alt: dados.titulo,
                                    src: dados.banner2 || "/img/image_icon.png",
                                    loader: _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_4__/* .customLoader */ .l,
                                    objectFit: "cover",
                                    layout: "fill",
                                    priority: true
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figcaption", {
                                    children: [
                                        "Imagem:",
                                        dados.titulo
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_detalhes_module_scss__WEBPACK_IMPORTED_MODULE_3___default().decor2)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                            className: (_detalhes_module_scss__WEBPACK_IMPORTED_MODULE_3___default().banner),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    alt: dados.titulo,
                                    src: dados.banner || "/img/image_icon.png",
                                    loader: _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_4__/* .customLoader */ .l,
                                    objectFit: "cover",
                                    layout: "fill",
                                    priority: true
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figcaption", {
                                    children: [
                                        "Imagem:",
                                        dados.titulo
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 39853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Index; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_BannerDefault__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50121);
/* harmony import */ var _components_MetaTags__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38280);
/* harmony import */ var _utils_ImageFindSizes__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34873);
/* harmony import */ var _conheca__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1602);
/* harmony import */ var _conhecerMais__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35121);
/* harmony import */ var _detalhes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75964);
/* harmony import */ var _opcoes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18949);
/* harmony import */ var _servicos__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(24599);
/* harmony import */ var _vantagens__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86616);












var __N_SSG = true;
function Index(param) {
    var plugApe = param.plugApe;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48, ref49;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var rota = "https://hypeempreendimentos.com.br".concat(router.asPath);
    if (!plugApe) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MetaTags__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    data: {
                        titulo: plugApe === null || plugApe === void 0 ? void 0 : (ref = plugApe.seo) === null || ref === void 0 ? void 0 : (ref1 = ref.seo) === null || ref1 === void 0 ? void 0 : ref1.metaTitle,
                        descricao: plugApe === null || plugApe === void 0 ? void 0 : (ref2 = plugApe.seo) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.seo) === null || ref3 === void 0 ? void 0 : ref3.metaDescription,
                        imagem: plugApe === null || plugApe === void 0 ? void 0 : (ref4 = plugApe.seo) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.seo) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.ogImage) === null || ref6 === void 0 ? void 0 : ref6.url,
                        rota: rota
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BannerDefault__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        image: {
                            src: (0,_utils_ImageFindSizes__WEBPACK_IMPORTED_MODULE_11__/* .imagemSizes */ .xQ)((0,_utils_ImageFindSizes__WEBPACK_IMPORTED_MODULE_11__/* .findImage */ .jw)(plugApe === null || plugApe === void 0 ? void 0 : plugApe.imagens, "plug-ape-banner"))
                        },
                        width: "100%",
                        height: "70vh",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            children: (ref8 = plugApe === null || plugApe === void 0 ? void 0 : (ref7 = plugApe.textos) === null || ref7 === void 0 ? void 0 : ref7.find(function(txt) {
                                return txt.referencia === "banner-principal-titulo";
                            })) === null || ref8 === void 0 ? void 0 : ref8.texto.conteudo
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_conheca__WEBPACK_IMPORTED_MODULE_5__["default"], {
                        dados: {
                            titulo: (ref10 = plugApe === null || plugApe === void 0 ? void 0 : (ref9 = plugApe.textos) === null || ref9 === void 0 ? void 0 : ref9.find(function(txt) {
                                return txt.referencia === "plug-ape-conheca-titulo";
                            })) === null || ref10 === void 0 ? void 0 : ref10.texto.conteudo,
                            texto: (ref12 = plugApe === null || plugApe === void 0 ? void 0 : (ref11 = plugApe.textos) === null || ref11 === void 0 ? void 0 : ref11.find(function(txt) {
                                return txt.referencia === "plug-ape-conheca-texto";
                            })) === null || ref12 === void 0 ? void 0 : ref12.texto.conteudo,
                            banner: (ref14 = plugApe === null || plugApe === void 0 ? void 0 : (ref13 = plugApe.imagens) === null || ref13 === void 0 ? void 0 : ref13.find(function(img) {
                                return img.referencia === "plug-ape-conheca-banner";
                            })) === null || ref14 === void 0 ? void 0 : ref14.imagem.url,
                            bannerMobile: (ref16 = plugApe === null || plugApe === void 0 ? void 0 : (ref15 = plugApe.imagens) === null || ref15 === void 0 ? void 0 : ref15.find(function(img) {
                                return img.referencia === "background-azul";
                            })) === null || ref16 === void 0 ? void 0 : ref16.imagem.url,
                            imagem: (ref18 = plugApe === null || plugApe === void 0 ? void 0 : (ref17 = plugApe.imagens) === null || ref17 === void 0 ? void 0 : ref17.find(function(img) {
                                return img.referencia === "plug-ape-conheca-logo";
                            })) === null || ref18 === void 0 ? void 0 : ref18.imagem.url
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vantagens__WEBPACK_IMPORTED_MODULE_10__["default"], {
                        dados: {
                            titulo: (ref20 = plugApe === null || plugApe === void 0 ? void 0 : (ref19 = plugApe.textos) === null || ref19 === void 0 ? void 0 : ref19.find(function(txt) {
                                return txt.referencia === "plug-ape-vantagens-titulo";
                            })) === null || ref20 === void 0 ? void 0 : ref20.texto.conteudo,
                            itens: plugApe === null || plugApe === void 0 ? void 0 : (ref21 = plugApe.listas) === null || ref21 === void 0 ? void 0 : ref21.find(function(lt) {
                                return lt.referencia === "plug-ape-vantagens-lista";
                            }).lista.itens,
                            icone: (ref23 = plugApe === null || plugApe === void 0 ? void 0 : (ref22 = plugApe.imagens) === null || ref22 === void 0 ? void 0 : ref22.find(function(img) {
                                return img.referencia === "plug-ape-check";
                            })) === null || ref23 === void 0 ? void 0 : ref23.imagem.url
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_servicos__WEBPACK_IMPORTED_MODULE_9__["default"], {
                        dados: {
                            titulo: (ref25 = plugApe === null || plugApe === void 0 ? void 0 : (ref24 = plugApe.textos) === null || ref24 === void 0 ? void 0 : ref24.find(function(txt) {
                                return txt.referencia === "plug-ape-servicos-titulo";
                            })) === null || ref25 === void 0 ? void 0 : ref25.texto.conteudo,
                            itens: plugApe === null || plugApe === void 0 ? void 0 : (ref26 = plugApe.listas) === null || ref26 === void 0 ? void 0 : ref26.find(function(lt) {
                                return lt.referencia === "plug-ape-servicos-lista";
                            }).lista.itens,
                            icone: (ref28 = plugApe === null || plugApe === void 0 ? void 0 : (ref27 = plugApe.imagens) === null || ref27 === void 0 ? void 0 : ref27.find(function(img) {
                                return img.referencia === "plug-ape-servicos-check";
                            })) === null || ref28 === void 0 ? void 0 : ref28.imagem.url,
                            banner: (ref30 = plugApe === null || plugApe === void 0 ? void 0 : (ref29 = plugApe.imagens) === null || ref29 === void 0 ? void 0 : ref29.find(function(img) {
                                return img.referencia === "background-azul";
                            })) === null || ref30 === void 0 ? void 0 : ref30.imagem.url
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_opcoes__WEBPACK_IMPORTED_MODULE_8__["default"], {
                        dados: {
                            titulo: (ref32 = plugApe === null || plugApe === void 0 ? void 0 : (ref31 = plugApe.textos) === null || ref31 === void 0 ? void 0 : ref31.find(function(txt) {
                                return txt.referencia === "plug-ape-opcoes";
                            })) === null || ref32 === void 0 ? void 0 : ref32.texto.titulo,
                            subtitulo: (ref34 = plugApe === null || plugApe === void 0 ? void 0 : (ref33 = plugApe.textos) === null || ref33 === void 0 ? void 0 : ref33.find(function(txt) {
                                return txt.referencia === "plug-ape-opcoes";
                            })) === null || ref34 === void 0 ? void 0 : ref34.texto.conteudo,
                            fotos: plugApe === null || plugApe === void 0 ? void 0 : (ref35 = plugApe.imagens) === null || ref35 === void 0 ? void 0 : ref35.filter(function(img) {
                                return img.referencia.includes("plug-ape-foto-personalizacao");
                            })
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_detalhes__WEBPACK_IMPORTED_MODULE_7__["default"], {
                        dados: {
                            titulo: (ref37 = plugApe === null || plugApe === void 0 ? void 0 : (ref36 = plugApe.textos) === null || ref36 === void 0 ? void 0 : ref36.find(function(txt) {
                                return txt.referencia === "plug-ape-opcoes-voce-no-processo";
                            })) === null || ref37 === void 0 ? void 0 : ref37.texto.titulo,
                            texto: (ref39 = plugApe === null || plugApe === void 0 ? void 0 : (ref38 = plugApe.textos) === null || ref38 === void 0 ? void 0 : ref38.find(function(txt) {
                                return txt.referencia === "plug-ape-opcoes-voce-no-processo";
                            })) === null || ref39 === void 0 ? void 0 : ref39.texto.conteudo,
                            banner: (ref41 = plugApe === null || plugApe === void 0 ? void 0 : (ref40 = plugApe.imagens) === null || ref40 === void 0 ? void 0 : ref40.find(function(img) {
                                return img.referencia === "plug-ape-foto-mosaico1";
                            })) === null || ref41 === void 0 ? void 0 : ref41.imagem.url,
                            banner2: (ref43 = plugApe === null || plugApe === void 0 ? void 0 : (ref42 = plugApe.imagens) === null || ref42 === void 0 ? void 0 : ref42.find(function(img) {
                                return img.referencia === "plug-ape-foto-mosaico2";
                            })) === null || ref43 === void 0 ? void 0 : ref43.imagem.url
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_conhecerMais__WEBPACK_IMPORTED_MODULE_6__["default"], {
                        dados: {
                            banner: (ref45 = plugApe === null || plugApe === void 0 ? void 0 : (ref44 = plugApe.imagens) === null || ref44 === void 0 ? void 0 : ref44.find(function(img) {
                                return img.referencia === "plug-ape-foto-mosaico2";
                            })) === null || ref45 === void 0 ? void 0 : ref45.imagem.url,
                            texto1: (ref47 = plugApe === null || plugApe === void 0 ? void 0 : (ref46 = plugApe.textos) === null || ref46 === void 0 ? void 0 : ref46.find(function(txt) {
                                return txt.referencia === "plug-ape-disponibilidade";
                            })) === null || ref47 === void 0 ? void 0 : ref47.texto.conteudo,
                            texto2: (ref49 = plugApe === null || plugApe === void 0 ? void 0 : (ref48 = plugApe.textos) === null || ref48 === void 0 ? void 0 : ref48.find(function(txt) {
                                return txt.referencia === "plug-ape-disponibilidade-atencao";
                            })) === null || ref49 === void 0 ? void 0 : ref49.texto.conteudo
                        }
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 18949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Opcoes; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var simple_react_lightbox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34930);
/* harmony import */ var _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37265);
/* harmony import */ var _opcoes_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47872);
/* harmony import */ var _opcoes_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_opcoes_module_scss__WEBPACK_IMPORTED_MODULE_3__);





var parse = __webpack_require__(30488);
function Opcoes(param) {
    var dados = param.dados;
    var options = {
        settings: {
            overlayColor: "rgba(25,136,124,0.71)",
            autoplaySpeed: 1500,
            transitionSpeed: 900,
            showDownloadButton: false
        },
        caption: {
            captionColor: "#a6cfa5",
            captionFontFamily: "Raleway, sans-serif",
            captionFontWeight: "300",
            captionTextTransform: "uppercase"
        }
    };
    if (!dados) return null;
    var titulo = dados.titulo, subtitulo = dados.subtitulo, fotos = dados.fotos;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_opcoes_module_scss__WEBPACK_IMPORTED_MODULE_3___default().section),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                children: parse(titulo)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                children: parse(subtitulo)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(simple_react_lightbox__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(simple_react_lightbox__WEBPACK_IMPORTED_MODULE_2__/* .SRLWrapper */ .Iv, {
                        options: options,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_opcoes_module_scss__WEBPACK_IMPORTED_MODULE_3___default().containerImage),
                            children: fotos.map(function(foto) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: (_opcoes_module_scss__WEBPACK_IMPORTED_MODULE_3___default().image),
                                    href: foto.imagem.url,
                                    tabIndex: -1,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                alt: "Imagem Ilustrativa Plug Ap\xea",
                                                objectFit: "cover",
                                                src: foto.imagem.url,
                                                loader: _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_4__/* .customLoader */ .l,
                                                width: "900",
                                                height: "1200"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figcaption", {
                                                children: "Imagem Ilustrativa Plug Ap\xea"
                                            })
                                        ]
                                    })
                                }, foto.imagem.url);
                            })
                        })
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 24599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Servicos; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_BannerDefault__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50121);
/* harmony import */ var _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37265);
/* harmony import */ var _servicos_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11347);
/* harmony import */ var _servicos_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_servicos_module_scss__WEBPACK_IMPORTED_MODULE_3__);





var parse = __webpack_require__(30488);
function Servicos(param) {
    var dados = param.dados;
    if (!dados) return null;
    var titulo = dados.titulo, itens = dados.itens, icone = dados.icone, banner = dados.banner;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BannerDefault__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        image: {
            src: banner
        },
        width: "100%",
        height: "fit-content",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_servicos_module_scss__WEBPACK_IMPORTED_MODULE_3___default().section),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    children: parse(titulo)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    children: itens.map(function(servico) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            alt: "Imagem de ap personalizado",
                                            src: icone,
                                            loader: _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_4__/* .customLoader */ .l,
                                            width: 30,
                                            height: 30
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figcaption", {
                                            children: "Imagem de ap personalizado"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    children: parse(servico.item)
                                })
                            ]
                        }, servico.id);
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 86616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Vantagens; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37265);
/* harmony import */ var _vantagens_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44759);
/* harmony import */ var _vantagens_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_vantagens_module_scss__WEBPACK_IMPORTED_MODULE_2__);




var parse = __webpack_require__(30488);
function Vantagens(param) {
    var dados = param.dados;
    if (!dados) return null;
    var titulo = dados.titulo, itens = dados.itens, icone = dados.icone;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_vantagens_module_scss__WEBPACK_IMPORTED_MODULE_2___default().section),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                children: titulo && parse(titulo)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_vantagens_module_scss__WEBPACK_IMPORTED_MODULE_2___default().cards),
                children: itens.map(function(vantagem) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_vantagens_module_scss__WEBPACK_IMPORTED_MODULE_2___default().card),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
                                className: (_vantagens_module_scss__WEBPACK_IMPORTED_MODULE_2___default().icon),
                                children: [
                                    icone && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        alt: "\xcdcone de item do plug ap\xea",
                                        src: icone || "/img/image_icon.png",
                                        loader: _utils_customLoaderImage__WEBPACK_IMPORTED_MODULE_3__/* .customLoader */ .l,
                                        width: 32,
                                        height: 32
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figcaption", {
                                        children: "\xcdcone de item do plug ap\xea"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                children: parse(vantagem.item)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: parse(vantagem.descricao)
                            })
                        ]
                    }, vantagem.id);
                })
            })
        ]
    });
}


/***/ }),

/***/ 34873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jw": function() { return /* binding */ findImage; },
/* harmony export */   "xQ": function() { return /* binding */ imagemSizes; }
/* harmony export */ });
/* unused harmony export imagemSizeDestructure */
// eslint-disable-next-line import/prefer-default-export
var imagemSizeDestructure = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var data = props === null || props === void 0 ? void 0 : props.imagem;
    if (data === null || data === void 0 ? void 0 : (ref = data.sizes) === null || ref === void 0 ? void 0 : (ref1 = ref.large) === null || ref1 === void 0 ? void 0 : ref1.url) {
        return data.sizes.large;
    }
    if (data === null || data === void 0 ? void 0 : (ref2 = data.sizes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.medium) === null || ref3 === void 0 ? void 0 : ref3.url) {
        return data.sizes.medium;
    }
    if (data === null || data === void 0 ? void 0 : (ref4 = data.sizes) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.small) === null || ref5 === void 0 ? void 0 : ref5.url) {
        return data.sizes.small;
    }
    if (data === null || data === void 0 ? void 0 : (ref6 = data.sizes) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.square) === null || ref7 === void 0 ? void 0 : ref7.url) {
        return data.sizes.square;
    }
    if (data === null || data === void 0 ? void 0 : (ref8 = data.sizes) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.thumbnail) === null || ref9 === void 0 ? void 0 : ref9.url) {
        return data.sizes.thumbnail;
    }
    if (data === null || data === void 0 ? void 0 : data.url) {
        return data;
    }
    return "";
};
var imagemSizes = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var data = props === null || props === void 0 ? void 0 : props.imagem;
    if (data === null || data === void 0 ? void 0 : (ref = data.sizes) === null || ref === void 0 ? void 0 : (ref1 = ref.large) === null || ref1 === void 0 ? void 0 : ref1.url) {
        return data.sizes.large.url;
    }
    if (data === null || data === void 0 ? void 0 : (ref2 = data.sizes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.medium) === null || ref3 === void 0 ? void 0 : ref3.url) {
        return data.sizes.medium.url;
    }
    if (data === null || data === void 0 ? void 0 : (ref4 = data.sizes) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.small) === null || ref5 === void 0 ? void 0 : ref5.url) {
        return data.sizes.small.url;
    }
    if (data === null || data === void 0 ? void 0 : (ref6 = data.sizes) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.square) === null || ref7 === void 0 ? void 0 : ref7.url) {
        return data.sizes.square.url;
    }
    if (data === null || data === void 0 ? void 0 : (ref8 = data.sizes) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.thumbnail) === null || ref9 === void 0 ? void 0 : ref9.url) {
        return data.sizes.thumbnail.url;
    }
    if (data === null || data === void 0 ? void 0 : data.url) {
        return data.url;
    }
    return "";
};
var findImage = function(imagens, referencia) {
    return imagens === null || imagens === void 0 ? void 0 : imagens.find(function(img) {
        return img.referencia === referencia;
    });
};


/***/ }),

/***/ 67202:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"bannerDefault_bannerContainer___FPrj","childrenContainer":"bannerDefault_childrenContainer__kGyT8"};

/***/ }),

/***/ 85426:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"conheca_section__5jJuJ","text":"conheca_text__1rMi8","image":"conheca_image__MHP7f"};

/***/ }),

/***/ 84983:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"conhecerMais_section__RB_Xi"};

/***/ }),

/***/ 65773:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"detalhes_section__XdPkW","text":"detalhes_text__Tw7_7","decor1":"detalhes_decor1__8K2ie","decor2":"detalhes_decor2__KxO_a","banner":"detalhes_banner__t46es","banner2":"detalhes_banner2__TrDj3"};

/***/ }),

/***/ 47872:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"opcoes_section__M_lFu","containerImage":"opcoes_containerImage__ITqtE","image":"opcoes_image__cCQnR"};

/***/ }),

/***/ 11347:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"servicos_section__XUD7b"};

/***/ }),

/***/ 44759:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"vantagens_section__ZTqHs","cards":"vantagens_cards__bga9x","card":"vantagens_card__fGJpt","icon":"vantagens_icon__8BBtL"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3336,9774,2888,179], function() { return __webpack_exec__(5597); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);